var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useContext } from 'react';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { isTrue } from '../../helpers/utils';
import Column from '../Column';
import { StyledTable, StyledTableContainer, StyledTr } from '../DataGrid';
import gridData from '../DataGrid/gridData';
import Item from '../Item';
var DataGridColumn = function (props) {
    var column = props.column, rowData = props.rowData, rowIndex = props.rowIndex, otherValues = props.otherValues, identifier = props.identifier, restProps = __rest(props, ["column", "rowData", "rowIndex", "otherValues", "identifier"]);
    var _onCellSelect = useContext(WindowEventContext)._onCellSelect;
    if (rowData && rowData.length > 0) {
        return column.map(function (col, index) {
            var _a;
            var colData = rowData.find(function (c) {
                return c.column == index.toString();
            });
            var colId = (_a = col === null || col === void 0 ? void 0 : col.attributes) === null || _a === void 0 ? void 0 : _a.text;
            var isSelected = isTrue(colData === null || colData === void 0 ? void 0 : colData.selected);
            return (React.createElement(Item, __assign({ key: identifier + "-column-" + rowIndex + "-" + index, identifier: identifier + "_" + rowIndex + "_" + colId, parentWidget: restProps, type: "item", otherValues: otherValues, colId: colId, isCellSelected: isSelected, windowTheme: restProps.windowTheme }, colData, { onClick: function (e) {
                    _onCellSelect(identifier, rowIndex, colId, !isSelected);
                } })));
        });
    }
    return null;
};
var DataGridBody = function (props) {
    var row = props.row, identifier = props.identifier, item = props.item, restProps = __rest(props, ["row", "identifier", "item"]);
    var rowsCount = (row && Array.isArray(row) && row.length) || 0;
    var itemCount = (item && item.length) || 0;
    if (rowsCount > 0) {
        return row
            .filter(function (r) { return !isTrue(r.deleted); })
            .map(function (r, index) {
            var gridData = item && item.filter(function (i) { return i.row === index.toString(); });
            var attributes = r.attributes, rowNumber = r.rowNumber, fontColor = r.fontColor, backgroundColor = r.backgroundColor, restValues = __rest(r, ["attributes", "rowNumber", "fontColor", "backgroundColor"]);
            var _a = (attributes || {}).text, text = _a === void 0 ? '' : _a;
            var actualRowIndex = rowNumber ? +rowNumber : index;
            return (React.createElement(StyledTr, __assign({ key: identifier + "-row-" + index, fontColor: fontColor, backgroundColor: backgroundColor }, restProps, { type: "row" }),
                React.createElement("th", { scope: "row" }, text),
                React.createElement(DataGridColumn, __assign({ identifier: identifier, rowData: gridData, otherValues: restValues, rowIndex: actualRowIndex }, restProps))));
        });
    }
    else {
        if (item && itemCount > 0) {
            return __spreadArrays(Array(itemCount)).map(function (x, index) {
                var gridData = item.filter(function (i) { return i.row === index.toString(); });
                return (React.createElement(StyledTr, __assign({ key: identifier + "-row-" + index, fontColor: item.fontColor, backgroundColor: item.backgroundColor }, restProps, { type: "row" }),
                    React.createElement(DataGridColumn, __assign({ identifier: identifier, rowIndex: index, rowData: gridData }, restProps))));
            });
        }
        return null;
    }
};
var DataGrid = function (props) {
    var fields = useContext(WindowStateContext).fields;
    var identifier = props.identifier, row = props.row, column = props.column, item = props.item, attributes = props.attributes, parentWidget = props.parentWidget, className = props.className, restProps = __rest(props, ["identifier", "row", "column", "item", "attributes", "parentWidget", "className"]);
    var _a = gridData(fields, item, column, identifier), itemData = _a.itemData, rowData = _a.rowData;
    var verticalHeaderVisible = attributes.verticalHeaderVisible, minimumSize = attributes.minimumSize;
    verticalHeaderVisible =
        typeof verticalHeaderVisible !== 'undefined'
            ? isTrue(verticalHeaderVisible)
            : false;
    var columnsCount = (column && Array.isArray(column) && column.length) || 0;
    var _b = attributes.hideHeader, hideHeader = _b === void 0 ? false : _b;
    return (React.createElement(StyledTableContainer, __assign({}, minimumSize, { attributes: attributes }, restProps),
        React.createElement(StyledTable, __assign({ id: identifier }, className, restProps, { attributes: attributes, verticalHeaderVisible: verticalHeaderVisible }),
            !hideHeader && (React.createElement("thead", null,
                React.createElement(StyledTr, { type: "row" },
                    React.createElement("th", { scope: "row" }),
                    columnsCount > 0 &&
                        column.map(function (col, index) {
                            var attributes = col.attributes;
                            return (React.createElement(Column, __assign({ key: identifier + "_col_" + index, notHeader: "false", id: identifier + "_col_" + index }, restProps, { type: "column", attributes: attributes })));
                        })))),
            React.createElement("tbody", null,
                React.createElement(DataGridBody, __assign({ row: rowData, identifier: identifier, item: itemData }, restProps, { column: column }))))));
};
export default DataGrid;
//# sourceMappingURL=DataGrid.js.map